<template>
  <div class="px-6 py-5">

    <div class="columns">
      <div class="column is-half">
        <master-production-list/>
      </div>

      <div class="column is-half"> 
        <workstation-queues/>
      </div>
    </div>

  </div>
</template>

<script>
import MasterProductionList from '@/components/scheduling/MasterProductionList'
import WorkstationQueues from '@/components/scheduling/WorkstationQueues'

export default {
  components: { 
    MasterProductionList, WorkstationQueues
  }
}
</script>

<style lang="scss" scoped>
</style>